import { CoreEvent } from "@nrk/player-core/types.js";
import { ReactiveElement } from "@nrk/reactive-element";
import { getPositionFromEvent } from "../utils/dom.js";
import platform from "../utils/platform.js";
import { ScrubberRenderMixin } from "./scrubber-render-mixin.js";
class ScrubberElement extends ScrubberRenderMixin(ReactiveElement) {
  static get reactiveProperties() {
    return {
      ...super.reactiveProperties,
      dimensions: (element, _dimensions) => {
        element.width = element.offsetWidth;
      },
      // endTime - added by ScrubberRender mixin
      // isDragging - added by ScrubberRender mixin
      // isLive - added by ScrubberRender mixin
      // isRealtime - added by ScrubberRender mixin
      // isTimeRunning - added by ScrubberRender mixin
      // playbackRate - added by ScrubberRender mixin
      // playheadPosition - added by ScrubberRender mixin
      // pointerPosition - added by ScrubberRender mixin
      // seekableStep - added by ScrubberRender mixin
      // startTime - added by ScrubberRender mixin
      // width - added by ScrubberRender mixin
      activeSession: Object
    };
  }
  /** The current playback session (shadowed Player property) */
  activeSession;
  /** The Player dimensions (shadowed Player property) */
  dimensions;
  _unshadowAdditionalProperties;
  readyCallback() {
    super.readyCallback();
    this.addEventListener(platform.pointerEventTypes.enter, this);
    this.addEventListener(platform.pointerEventTypes.move, this);
    this.addEventListener(platform.pointerEventTypes.down, this);
    this._elInputRange?.addEventListener("change", this);
    this._unshadowAdditionalProperties = this.player.shadowProperties(["activeSession", "dimensions"], this);
  }
  disconnectedCallback() {
    this.removeEventListener(platform.pointerEventTypes.enter, this);
    this.removeEventListener(platform.pointerEventTypes.move, this);
    this.removeEventListener(platform.pointerEventTypes.down, this);
    this.removeEventListener(platform.pointerEventTypes.leave, this);
    document.removeEventListener(platform.pointerEventTypes.up, this);
    this._elInputRange?.removeEventListener("change", this);
    this._unshadowAdditionalProperties?.();
    super.disconnectedCallback();
  }
  updating(propName, oldValue) {
    super.updating(propName, oldValue);
    if (propName === "activeSession") {
      if (this.activeSession) {
        this.activeSession.on(CoreEvent.ScrubberUpdate, this.handleScrubberUpdate.bind(this));
      }
    } else if (propName === "isDragging") {
      if (this.isDragging) {
        this.classList.add("-scrubber--dragging");
      } else {
        this.classList.remove("-scrubber--dragging");
      }
    }
  }
  handleEvent(event) {
    const { type } = event;
    if (type === platform.pointerEventTypes.enter) {
      this.addEventListener(platform.pointerEventTypes.leave, this);
    } else if (type === platform.pointerEventTypes.move) {
      this.pointerPosition = getPositionFromEvent(this, event);
    } else if (type === platform.pointerEventTypes.down) {
      this.isDragging = true;
      document.addEventListener(platform.pointerEventTypes.up, this);
    } else if (type === platform.pointerEventTypes.up) {
      const oldStep = this.seekableStep;
      this.seekableStep = 1;
      if (this.pointerPosition === void 0) {
        this.pointerPosition = getPositionFromEvent(this, event);
      }
      this.isDragging = false;
      this.pointerPosition = void 0;
      document.removeEventListener(platform.pointerEventTypes.up, this);
      this.updateComplete.then(() => {
        if (this._elInputRange) {
          if (!this.isSeeking) {
            this._elInputRange.value = `${(this.endTime - this.startTime) * this.playheadPosition + this.startTime}`;
            this._elInputRange.dispatchEvent(new Event("change", { cancelable: true, bubbles: true }));
          }
          this.seekableStep = oldStep;
        }
      });
    } else if (type === "change") {
      if (this.isSeeking) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    } else if (type === platform.pointerEventTypes.leave) {
      this.removeEventListener(platform.pointerEventTypes.leave, this);
      this.pointerPosition = void 0;
    }
  }
  selectElements() {
    this._elPlayheadTime = this.querySelector('[type="playhead-time"]');
    this._elEndTime = this.querySelector('[type="end-time"]');
    this._elInputRange = this.querySelector('input[type="range"]');
    this._elPlayhead = this.querySelector('[type="playhead"]');
    this._elProgressBarPlayed = this.querySelector('[type="progressbar-played"]');
    this._elPointerTime = this.querySelector('[type="pointer-time"]');
    this._elStartTime = this.querySelector('[type="start-time"]');
    this._elScrubberImage = this.querySelector('[type="scrubber-image"]');
    super.selectElements();
  }
  handleScrubberUpdate(scrubberValues) {
    const { playheadPosition, endPosition, startPosition, startLiveTime } = scrubberValues;
    this.endTime = endPosition;
    this.startTime = startPosition;
    this.playheadPosition = (playheadPosition - startPosition) / (endPosition - startPosition);
    if (startLiveTime) {
      this.epochStartTime = (startLiveTime.getTime() - startLiveTime.getTimezoneOffset() * 6e4) / 1e3;
    }
  }
}
export {
  ScrubberElement
};
